module.exports = __webpack_public_path__ + "img/ic-grid.8c26dc0e.svg";